<!--
  Copyright (c) 2023 GM Global Technology Operations LLC. All rights reserved.
  This information is confidential and proprietary to GM Global Technology
  Operations LLC and may not be used, modified, copied or distributed.
  -->
<div class="page-container">
  <mat-icon class="icon material-icons-outlined">lock</mat-icon>
  <h1>Access Denied</h1>
  <mat-divider></mat-divider>
  <div class="text-content">
    <h3>You do to have permission to access this page.
      <br>
      Please contact the system administrator to request access.
    </h3>
  </div>
</div>
